import Styles from "./modal.module.css";
import { useState } from "react";
import { Button, Modal } from "antd"; // Import Modal and Button from Ant Design
import { useForm, SubmitHandler } from "react-hook-form";
import { ModalType, WinType } from "../Types";

import React, { useEffect } from "react";

const Address: React.FC<ModalType> = ({
    isModalVisible,
    details,
    updateData,
    ModalLoad,
    setisModalVisible,
}) => {
    const handleOk = () => {
        setisModalVisible(false);
    };
    const handleCancel = () => {
        setisModalVisible(false);
    };
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm<WinType>();
    useEffect(() => {
        if (details?.testimonial_url && details?.testimonial_url != "NA") {
            reset({ testimonial_url: details?.testimonial_url });
        } else {
            reset({ testimonial_url: "" });
        }
    }, [isModalVisible]);
    const onSubmit: SubmitHandler<WinType> = (data) => {
        updateData(data);
    };

    return (
        <>
            <Modal
                // title="Custom Modal"
                open={isModalVisible}
                onOk={handleOk}
                footer={null}
                onCancel={handleCancel}
                style={{ width: "80vw" }}
                className={Styles["custom_modal_navbar"]}>
                <div className={Styles["adress_form"]}>
                    <div className={Styles["form"]}>
                        <h3 style={{ textAlign: "center" }}>Testimonials</h3>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className={Styles["Form-control"]}>
                                <label>
                                    Testimonials <span>*</span>
                                </label>
                                <input
                                    type="text"
                                    {...register("testimonial_url", {
                                        required: "This field is required",
                                    })}
                                />
                                {errors?.public_url && (
                                    <p>{errors?.public_url?.message}</p>
                                )}
                            </div>

                            <Button
                                loading={ModalLoad}
                                onClick={handleSubmit(onSubmit)}>
                                Submit
                            </Button>
                        </form>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default Address;
